module.exports = __webpack_public_path__ + "static/bar-7570255ed8280702031f3b8a771c598b.jpg";